import type { AncestryDefinition, CharacterOptions } from '../../shared/game/character-build.js';

/** Core Rules p. 23 (common). */
export const halfling: AncestryDefinition = {
  id: 'halfling', name: 'Halfling', size: 'small', trait: 'Elusive', skillBonus: 0, initiativeBonus: 0, skillBonuses: { stealth: 1 }, elusive: true,
  description: 'Small, quick and hard to pin down, Halflings are easy to overlook and harder still to catch. Their luck has a way of turning up just when things go wrong.',
  traitDescription: '+1 Stealth. (1/Safe Rest) If you fail a save, you can succeed instead.',
  skinColors: [0xf1c9a5, 0xe6b48f, 0xd5a384, 0xc99776, 0xb27d58, 0x8d5a3b, 0x6b4129, 0x4a2c1d],
  hairColors: [0x1c1714, 0x382c29, 0x4a3022, 0x6b4428, 0x8a5a32, 0xb07a44, 0xc9a165, 0xa64b2a, 0x8f8a84, 0xebe7df],
};
export const halflingBodies: CharacterOptions['bodies'] = [
  { id: 'halfling-male', name: 'Masculine', height: [1, 1.3], ancestryId: 'halfling' },
  { id: 'halfling-female', name: 'Feminine', height: [.95, 1.25], ancestryId: 'halfling' },
];
